import { render } from "./UserManager.vue?vue&type=template&id=1ae13c8e&scoped=true"
import script from "./UserManager.vue?vue&type=script&lang=js"
export * from "./UserManager.vue?vue&type=script&lang=js"

import "./UserManager.vue?vue&type=style&index=0&id=1ae13c8e&lang=scss&scoped=true"
import "./UserManager.vue?vue&type=style&index=1&id=1ae13c8e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae13c8e"]])

export default __exports__